import React, { useState, useEffect, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
 
  MapPin,
  Layers,
  CheckCircle2,
  Circle,
  Trash2,
  Package,
  ChevronRight,
  ChevronDown,  
  ChevronUp       
} from "lucide-react";
import { faTruck ,faTrash ,faPhone, faEnvelope ,faImage,faChevronUp, faChevronDown ,faTimes  } from "@fortawesome/free-solid-svg-icons";
import { X, Phone, Mail, MessageCircle} from "lucide-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { decryptData } from "../../../utils/storageCrypto";

 
const awardsData = [
  {
    id: 1,
    isAwarded: true,
    companyName: "Sai Enterprises",
    contactPerson: "Hari",
    phone: "9533984542",
    location: "Gurunanak Colony Road",
    Type: "Sai Enterprises",
    itemsCount: 4,
    amount: 5350,
    requestDate: "20 Dec 2025",
    requestTime: "07:14:35 PM"
  },
  {
    id: 2,
    isAwarded: false,
    companyName: "Dwaraka Enterprises",
    contactPerson: "Prasad",
    phone: "9845123678",
    location: "Benz Circle",
    Type: "Brickbucket",
    itemsCount: 3,
    amount: 5400,
    requestDate: "20 Dec 2025",
    requestTime: "07:14:35 PM"
  }
];

const pricingSummary = {
  subtotal: 10750,
  tax: 1935,
  total: 12685,
  buildcoinsDiscount: 1268
};

const extractPincode = (address = "") => {
  const match = address.match(/\b\d{6}\b/);
  return match ? match[0] : "--";
};

const extractCityState = (address = "") => {
  if (!address) return { city: "--", state: "--" };

  const parts = address.split(",").map(p => p.trim());
  const pinIndex = parts.findIndex(p => /\b\d{6}\b/.test(p));

  if (pinIndex > 0) {
    return {
      city: parts[pinIndex - 1] || "--",
      state: parts[pinIndex].replace(/\b\d{6}\b/g, "").trim() || "--",
    };
  }

  return {
    city: parts[parts.length - 3] || "--",
    state: parts[parts.length - 2] || "--",
  };
};

const cleanAreaAddress = (address = "") => {
  if (!address) return "--";

  // remove pincode
  let cleaned = address.replace(/\b\d{6}\b/g, "");

  const parts = cleaned
    .split(",")
    .map(p => p.trim())
    .filter(Boolean);

  // remove last 3 parts → City, State, Country
  if (parts.length > 3) {
    return parts.slice(0, parts.length - 3).join(", ");
  }

  return parts.join(", ") || "--";
};




/* ================= STEP UI HELPER ================= */
const RenderRFQStepContent = ({activeStep,isStepLoading,customerInfo, rfqItemResponses, setShowPopup, shipmentBlocks, suppliers,
  productCategories,
  selection,
  setSelection,
  isCategoryFullySelected,
  toggleCategorySelection,
  matrix,
  summary,
 awardedItems,
  vehicles ,
    groups,
  setGroups,
  moveSupplier,
  moveItem,
  groupWeight,
  addGroup,
  paymentDetails,
  onSuccessPayment,
  rfq, 
  finalRfqData,
onOpenAssignSupplier,
 openSupplierResponsePopup ,
//  setConfirmDeleteOpen,
 setGroupToDelete,
setShowPopupMessages,
  setPopupMessage,
  setPopupType,
  setSelectedAlternatives,
fareLoading,
setFareLoading 

  
}) => {
const imageurl = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES;
  const today = new Date().toISOString().split("T")[0];
  const [paymentDate, setPaymentDate] = useState(today);   
const [paymentMode, setPaymentMode] = useState("Cash");  
const [amount, setAmount] = useState(customerInfo?.pricing_summary?.final?.total || 0);
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
const [collapsedAlternatives, setCollapsedAlternatives] = useState({});

const [isDown, setIsDown] = useState(false);
const [startX, setStartX] = useState(0);
const [scrollLeft, setScrollLeft] = useState(0);
const [isDragging, setIsDragging] = useState(false);
const [showAcceptedPopup, setShowAcceptedPopup] = useState(false);
const [activeContact, setActiveContact] = useState(null);
const [vehicleLoadingGroup, setVehicleLoadingGroup] = useState(null);
// 🔥 ADD THESE 2 LINES ONLY
const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
const [groupToDeleteIndex, setGroupToDeleteIndex] = useState(null);


const handleMouseDown = (e) => {
  setIsDown(true);
  setStartX(e.pageX - e.currentTarget.offsetLeft);
  setScrollLeft(e.currentTarget.scrollLeft);
};

const handleMouseLeave = () => setIsDown(false);
const handleMouseUp = () => setIsDown(false);

const handleMouseMove = (e) => {
  if (!isDown) return;
  e.preventDefault();
  const x = e.pageX - e.currentTarget.offsetLeft;
  const walk = (x - startX) * 1.5; // speed control
  e.currentTarget.scrollLeft = scrollLeft - walk;
};

  /* Mode-specific states */
  const [upiDetails, setUpiDetails] = useState({
    upi_id: "",
    transaction_id: "",
    payer_name: ""
  });

  const [cardDetails, setCardDetails] = useState({
    last_four_digits: "",
    card_type: "",
    transaction_id: ""
  });

  const [bankDetails, setBankDetails] = useState({
    from_account: "",
    to_account: "",
    ifsc_code: "",
    transaction_reference: ""
  });

  const [gatewayDetails, setGatewayDetails] = useState({
    gateway_name: "",
    gateway_transaction_id: "",
    gateway_payment_id: "",
    gateway_order_id: ""
  });
//console.log("customerInfo::::",customerInfo);
//console.log("suppliers::::",suppliers);
  // 🔹 ADD THIS: Check if Response Time is Expired
const isResponseExpired = useMemo(() => {
  if (!finalRfqData?.waiting_time_expired_at) return false;
  const expiry = new Date(finalRfqData.waiting_time_expired_at).getTime();
  return Date.now() > expiry;
}, [finalRfqData?.waiting_time_expired_at]);

  useEffect(() => {
  if (customerInfo?.pricing_summary?.final?.total) {
    setAmount(customerInfo.pricing_summary.final.total);
  }
}, [customerInfo]);



const selectedAlternativeProducts = useMemo(() => {
  const alternatives = [];

  Object.entries(selection).forEach(([selectedItemId, supplierId]) => {

    // Check if this selected item is an alternative
    const isAlternative = suppliers.some(supplier =>
      supplier.response_items?.some(r =>
        r.item_id === selectedItemId &&
        r.requested_item_id &&
        r.requested_item_id !== selectedItemId
      )
    );

    if (isAlternative) {
      alternatives.push({
        item_id: selectedItemId,
        supplier_id: supplierId
      });
    }
  });

  return alternatives;
}, [selection, suppliers]);

useEffect(() => {
  setSelectedAlternatives(selectedAlternativeProducts);
}, [selectedAlternativeProducts, setSelectedAlternatives]);

const toggleAlternatives = (categoryId, itemId) => {
  const key = `${categoryId}-${itemId}`;
  setCollapsedAlternatives(prev => ({
    ...prev,
    [key]: !prev[key]
  }));
};

// ✅ FIXED: Robust delivery fare trigger
useEffect(() => {
  // Only proceed if there are eligible groups
  const eligibleGroups = groups.filter(g => g.deliveredByBrickbucket === "true");
  if (!eligibleGroups.length) return;

  console.log("🚚 Triggering fare calculation for", eligibleGroups.length, "groups");

  // Debounced API call
  const timeoutId = setTimeout(async () => {
    try {
      const payload = buildFarePayload();
      console.log("📦 Fare payload:", payload);
      
      if (payload.length > 0) {
        await fetchDeliveryFare(payload);
      }
    } catch (error) {
      console.error("Fare calculation failed:", error);
    }
  }, 800); // Increased debounce to 800ms

  return () => clearTimeout(timeoutId);
}, [
  // ✅ STABLE DEPENDENCIES - Simple primitive values
  groups.map(g => g.deliveredByBrickbucket).join('|'),  // Brickbucket status changes
  groups.map(g => Object.keys(g.suppliers || {}).length).join('|'),  // Supplier count changes
  groups.map(g => g.suppliers ? Object.values(g.suppliers).reduce((acc, s) => acc + (s.items?.length || 0), 0) : 0).join('|'),  // Item count changes
  JSON.stringify(groups.map(g => g.groupId).sort())  // Group order/structure
]);


useEffect(() => {
  productCategories.forEach((category) => {
    category.items.forEach((item) => {
      const validSuppliers = suppliers.filter((supplier) => {
        const r = supplier.response_items?.find((x) => x.item_id === item.item_id);
        return r && (supplier.status === "Accepted" || supplier.status === "Counter Offer");
      });

      const bestSupplier = validSuppliers.reduce((best, supplier) => {
        const r = supplier.response_items?.find((x) => x.item_id === item.item_id);
        const unit = r?.proposed_price > 0 ? r.proposed_price : r?.requested_price;
        const total = unit * item.quantity;

        if (!best || total < best.total) {
          return {
            vendor_id: supplier.vendor_id,
            supplierName: supplier.company_name || supplier.name,
            unit,
            total
          };
        }
        return best;
      }, null);

      // ✅ MAIN ITEMS AUTO-SELECT (your existing logic)
      const mainKey = `${item.item_id}-MAIN`;
      if (!selection[mainKey] && bestSupplier) {
        setSelection((prev) => ({
          ...prev,
          [mainKey]: {
            vendor_id: bestSupplier.vendor_id,
            supplierName: bestSupplier.supplierName,
            unit: bestSupplier.unit,
            total: bestSupplier.total,
            isAlternative: false
          }
        }));
      }
    });
  });
}, [productCategories, suppliers]);


//   useEffect(() => {
//   productCategories.forEach((category) => {
//     category.items.forEach((item) => {
//       // Find alternatives
//       const alternatives = suppliers
//         .flatMap((s) =>
//           s.response_items?.filter(
//             (r) => r.requested_item_id === item.item_id && r.item_id !== item.item_id
//           ) || []
//         )
//         .reduce((acc, cur) => {
//           if (!acc.find((i) => i.item_id === cur.item_id)) acc.push(cur);
//           return acc;
//         }, []);

//       alternatives.forEach((altItem) => {
//         const validSuppliers = suppliers.filter((supplier) => {
//           const r = supplier.response_items?.find((x) => x.item_id === altItem.item_id);
//           return r && (supplier.status === "Accepted" || supplier.status === "Counter Offer");
//         });

//         const bestAltSupplier = validSuppliers.reduce((best, supplier) => {
//           const r = supplier.response_items?.find((x) => x.item_id === altItem.item_id);
//           const unit = r?.proposed_price > 0 ? r.proposed_price : r?.requested_price;
//           const total = unit * altItem.quantity;

//           if (!best || total < best.total) {
//             return {
//               vendor_id: supplier.vendor_id,
//               supplierName: supplier.company_name || supplier.name,
//               unit,
//               total
//             };
//           }
//           return best;
//         }, null);

//         // ✅ AUTO-SELECT BEST ALTERNATIVE
//         const altKey = `${altItem.item_id}-ALT-${item.item_id}`;
//         if (!selection[altKey] && bestAltSupplier) {
//           setSelection((prev) => ({
//             ...prev,
//             [altKey]: {
//               vendor_id: bestAltSupplier.vendor_id,
//               supplierName: bestAltSupplier.supplierName,
//               unit: bestAltSupplier.unit,
//               total: bestAltSupplier.total,
//               isAlternative: true
//             }
//           }));
//         }
//       });
//     });
//   });
// }, [productCategories, suppliers]);


 // console.log("summary:::",summary);

  if (isStepLoading) {
  return (
    <div className=" flex w-full  justify-center pt-4 bg-opacity-50 ">
    <div className=" flex space-x-2 w-full justify-center items-center h-20  ">
      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0s' }} />
      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }} />
      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }} />
      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.3s' }} />
      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.4s' }} />
    </div>
    </div>
  );
}

const handleAddDeliveryCharge = ()=>{
    if(!groups.length > 0)return 0
   let  DeliveryCHarge = 0
   groups.forEach(element => {
    DeliveryCHarge += Number(element.deliveryCharge);
});

return DeliveryCHarge
}



const formatAmount = (value) => {
  if (!value && value !== 0) return "--";
  
  const num = Number(value);
  if (isNaN(num)) return "--";
  
  // Indian Number Format (Lakhs/Crores): 12,34,567.89
  return num.toLocaleString('en-IN', {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0
  });
};

const handleSavePayment = async () => {
  try {
    const encryptedToken = sessionStorage.getItem('token');
       const token = decryptData(encryptedToken);
    const encryptedHubId = sessionStorage.getItem('hubId');
    const hubId = decryptData(encryptedHubId);   
    const rfqid = rfq?.rfq_id;
  if (!paymentDate) {
      setPopupType("400");
      setPopupMessage("Payment date is required");
      setShowPopupMessages(true);
      return;
    }

    if (!paymentMode) {
      setPopupType("400");
      setPopupMessage("Payment mode is required");
      setShowPopupMessages(true);
      return;
    }

    if (!amount) {
      setPopupType("400");
      setPopupMessage("Payment amount is required");
      setShowPopupMessages(true);
      return;
    }

    setLoading(true);

    const payload = {
      payment_date: paymentDate,
      payment_mode: paymentMode,
      amount: Number(amount),
      description,
      rfq_id: rfqid,
      order_id: rfq?.quotation_id,
      customer_id: customerInfo?.customer?._id,
      hubId: customerInfo?.customer?.hubId || hubId,
    };

    console.log("hubId:",hubId)
    console.log("payload:::::",payload);
 

    if (paymentMode === "UPI") payload.upi_details = upiDetails;
    if (paymentMode === "Card") payload.card_details = cardDetails;
    if (["Bank Transfer", "Cheque"].includes(paymentMode)) {
      payload.bank_transfer_details = bankDetails;
    }
    if (paymentMode === "Gateway") payload.gateway_details = gatewayDetails;


    const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}customer/salesorder/process-customer-payment`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-token": token
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();
    console.log("Payment Response:", data);
    
     if (!response.ok || !data.success) {
      setPopupType("500"); 
      setPopupMessage(data.message || "Payment creation failed");
      setShowPopupMessages(true);
      return;
    }

    setPopupType("200or201");
    setPopupMessage("Payment saved successfully");
    setShowPopupMessages(true);
    setTimeout(() => {
      setShowPopupMessages(false);
    }, 3000);

    // refresh parent data
    onSuccessPayment();
 } catch (error) {
    console.error("Failed to save payment:", error);
    setPopupType("500");
    setPopupMessage(error.message || "Failed to save payment");
    setShowPopupMessages(true);

  } finally {
    setLoading(false);
  }
};

// Group items by product category (only when finalRfqData exists)
const groupedItems =
  finalRfqData &&
  Array.isArray(finalRfqData.items) &&
  Array.isArray(finalRfqData.product_categories)
    ? finalRfqData.items.reduce((acc, item) => {
        const category =
          finalRfqData.product_categories.find(
            (c) => c._id === item.product_category_id
          )?.product_category_name || "Others";

        if (!acc[category]) acc[category] = [];
        acc[category].push(item);

        return acc;
      }, {})
    : {};



const address = customerInfo?.delivery_address || {};
const fullArea = address.area || "--";

const pincode =
  address.pincode && address.pincode !== "--"
    ? address.pincode
    : extractPincode(fullArea);

const { city, state } =
  address.city !== "--" && address.state !== "--"
    ? { city: address.city, state: address.state }
    : extractCityState(fullArea);

const area = cleanAreaAddress(fullArea);



// 🔹 BUILD API PAYLOAD
const buildFarePayload = () => {
  if (!groups?.length) return [];

  return groups
    .filter(g => g.deliveredByBrickbucket === "true")
    .map(g => {

      // 🔥 Extract items
      const items = Object.values(g.suppliers || {}).flatMap(s =>
        (s.items || []).map(item => ({
          itemId: item?.item_id,
          quantity: item?.quantity,
          weight: item?.weight?.value || 0,
          weight_unit: item?.weight?.unit || "kg",
          length: item?.dimensions?.length || 0,
          length_unit: item?.dimensions?.unit || "cm",
          width: item?.dimensions?.width || 0,
          width_unit: item?.dimensions?.unit || "cm",
          height: item?.dimensions?.height || 0,
          height_unit: item?.dimensions?.unit || "cm"
        }))
      );

      // 🔥 Extract suppliers with LOCATION from MAIN suppliers array
      const suppliersPayload = Object.values(g.suppliers || {})
        .map(s => {
          const fullSupplier = suppliers.find(
            sup => sup.vendor_id === s.supplierId
          );

          const lat = fullSupplier?.location?.lat;
          const lng = fullSupplier?.location?.lng;

          // ❌ Skip suppliers without location
          if (!lat || !lng) return null;

          return {
            supplierId: s.supplierId,
            lat,
            lng
          };
        })
        .filter(Boolean); // remove nulls

      return {
        groupId: g.groupId,
        items,
        suppliers: suppliersPayload,

        deliveryLocation: {
          lat: customerInfo?.delivery_address?.latitude,
          lng: customerInfo?.delivery_address?.longitude
        }
      };
    })
    .filter(g => g.items.length && g.suppliers.length);
};

// 🔹 API CALL
const fetchDeliveryFare = async (payload) => {
  console.log("Fetching fare for payload:", payload);
  try {
    setFareLoading(true);

        // 🔥 10s MAX LOADER - EVEN IF API HANGS
    const maxLoaderTimer = setTimeout(() => {
      console.log("⏰ Max loader time reached - hiding");
      setFareLoading(false);
    }, 10000); // ✅ 10 seconds max

    const encryptedToken = sessionStorage.getItem("token");
    const token = decryptData(encryptedToken);

    const res = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/salesorder/get-delivery-fare-for-delivery-groups`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
        body: JSON.stringify({ groups: payload }),
      }
    );

    const data = await res.json();
    console.log("Fare API response:", data);

    if (!res.ok || !data.success) {
      console.error("Fare API failed", data);
      return;
    }

    // ✅ UPDATE GROUPS FROM RESPONSE
setGroups(prev =>
  prev.map(g => {
    const result = data.results.find(r => r.groupId === g.groupId);
    if (!result) return g;

    const recommended = result.vehicles.find(v => v.recommended);

    return {
      ...g,

      // ✅ FIXED MAPPING
      distance: result.totalDistanceKm,
      totalWeight: result.totalWeightKg,

      vehicles: result.vehicles,

      vehicleId: recommended?.id || "",
      deliveryCharge: recommended?.customerFare || 0
    };
  })
);

  } catch (err) {
    console.error("Fare API error:", err);
  } finally {
    setFareLoading(false);
  }
};


const moveItemToGroup = (item, fromGroupId, toGroupId) => {
  if (!toGroupId || fromGroupId === toGroupId) return;

  const updated = JSON.parse(JSON.stringify(groups));

  let movedItem = null;
  let fromSupplierId = null;
  let fromSupplierName = null;

  // 🔥 REMOVE ITEM FROM SOURCE GROUP
  updated.forEach(g => {
    if (g.groupId !== fromGroupId) return;

    if (!g.suppliers) return;

    Object.values(g.suppliers).forEach(s => {
      if (!s || !s.items) return;

      const index = s.items.findIndex(i => i.item_id === item.item_id);

      if (index !== -1) {
        movedItem = s.items.splice(index, 1)[0];
        fromSupplierId = s.supplierId;
        fromSupplierName = s.supplierName;
      }
    });

    // 🔥 REMOVE EMPTY SUPPLIERS
    Object.keys(g.suppliers || {}).forEach(key => {
      if (!g.suppliers[key].items?.length) {
        delete g.suppliers[key];
      }
    });
  });

  if (!movedItem) {
    console.warn("Item not found in source group");
    return;
  }

  // 🔥 ADD ITEM TO TARGET GROUP
  updated.forEach(g => {
    if (g.groupId !== toGroupId) return;

    if (!g.suppliers) g.suppliers = {};

    if (!g.suppliers[fromSupplierId]) {
      g.suppliers[fromSupplierId] = {
        supplierId: fromSupplierId,
        supplierName: fromSupplierName,
        items: []
      };
    }

    g.suppliers[fromSupplierId].items.push(movedItem);
  });

  // ✅ REMOVE EMPTY GROUPS (IMPORTANT FIX)
  const cleanedGroups = updated.filter(g => {
    if (!g.suppliers) return false;

    const totalItems = Object.values(g.suppliers).reduce(
      (sum, s) => sum + (s.items?.length || 0),
      0
    );

    return totalItems > 0;
  });

  const targetGroupIndex = groups.findIndex(g => g.groupId === toGroupId);

  setGroups(cleanedGroups);
};

const groupedItemResponses  = {};

const calculateItemTotal = (itemId) => {
  const selected = selection[itemId];
  return selected?.total || 0;
};

const calculateGrandTotal = () => {
  return Object.keys(selection).reduce((total, itemId) => {
    return total + calculateItemTotal(itemId);
  }, 0);
};

const getSelectedItemsCount = () => {
  return Object.keys(selection).length;
};

suppliers.forEach((vendor) => {
  vendor.response_items.forEach((item) => {

    if (!groupedItemResponses[item.item_name]) {
      groupedItemResponses[item.item_name] = {
        item_image: item.item_image,
        vendors: []
      };
    }

    groupedItemResponses[item.item_name].vendors.push({
      company_name: vendor.company_name,
      mobile_number: vendor.mobile_number,
      status: vendor.status,
      price: item.selling_price ?? item.cost_price ?? "--",
      uom: item.UOM || " ",
       qty: item.quantity || " "

    });

  });
});



const handleDeleteGroup = (deleteIndex) => {
  const groupToDelete = groups[deleteIndex];

  // 👉 Always move to DG-1 (index 0)
  const targetGroup = groups[0];

  // 🔥 Clone groups safely
  const updated = JSON.parse(JSON.stringify(groups));

  // 🔥 Extract items from deleting group
  const deletingGroup = updated[deleteIndex];

  if (deletingGroup?.suppliers) {
    Object.values(deletingGroup.suppliers).forEach((supplier) => {
      
      // 👉 If supplier not exist in DG-1, create
      if (!updated[0].suppliers[supplier.supplierId]) {
        updated[0].suppliers[supplier.supplierId] = {
          supplierId: supplier.supplierId,
          supplierName: supplier.supplierName,
          items: []
        };
      }

      // 👉 Move items
      updated[0].suppliers[supplier.supplierId].items.push(
        ...supplier.items
      );
    });
  }

  // 🔥 Remove deleted group
  updated.splice(deleteIndex, 1);

  setGroups(updated);
};


  // STEP 1: RFQ PLACED
  if (activeStep === 1) {
  return (
    <div className=" rounded-md  p-6 space-y-6">
      {/* TOP ROW - 3 ROUNDED CARDS */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">

  {/* 1. RFQ DETAILS */}
  <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-md p-4 border border-green-200">
    <div className="flex items-center mb-3">
      <div className="w-6 h-6 bg-green-500 rounded-md flex items-center justify-center mr-2 shadow-sm">
        <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <h3 className="text-base font-semibold text-gray-900">RFQ Details</h3>
    </div>

    <div className="text-sm space-y-2">
      {/* ROW 1 */}
      <div className="flex justify-between">
        <span><span className="font-semibold text-gray-700">RFQ No:</span>{customerInfo?.rfq_number}</span>
                       <span><span className="font-semibold text-gray-700">Status:</span>{customerInfo?.order_status}</span>
      </div>
      
      {/* ROW 2 */}
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-2">
          <span className="font-semibold text-gray-700">Total Items:</span>
          <span className="bg-emerald-100 text-emerald-800 px-2 py-0.5 rounded-full text-xs font-medium">{customerInfo?.items_summary?.total_requested}</span>
        </div>
      </div>
    </div>
  </div>

  {/* 2. CUSTOMER INFO */}
  <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-md p-4 border border-blue-200">
    <div className="flex items-center mb-3">
      <div className="w-6 h-6 bg-blue-500 rounded-md flex items-center justify-center mr-2 shadow-sm">
        <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
      </div>
      <h3 className="text-base font-semibold text-gray-900">Customer Info</h3>
    </div>

    <div className="text-sm space-y-2">
      {/* ROW 1 */}
      <div className="flex justify-between">
        <span><span className="font-semibold text-gray-700">Name:</span> {customerInfo?.customer?.name}</span>
        <span><span className="font-semibold text-gray-700">Mobile:</span> {customerInfo?.customer?.mobile}</span>
      </div>

      {/* ROW 2 */}
      <div>
        <span className="font-semibold text-gray-700">Company:</span> {customerInfo?.customer?.company_name}
      </div>
    </div>
  </div>

  {/* 3. PROJECT INFO */}
  <div className="bg-gradient-to-r from-purple-50 to-violet-50 rounded-md p-4 border border-purple-200">
    <div className="flex items-center mb-3">
      <div className="w-6 h-6 bg-purple-500 rounded-md flex items-center justify-center mr-2 shadow-sm">
        <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      </div>
      <h3 className="text-base font-semibold text-gray-900">Delivery Details</h3>
    </div>

    <div className="text-sm space-y-1">
      {/* ROW 1 */}
   {customerInfo?.project?.name &&
 customerInfo.project.name.trim() !== "--" && (
  <div className="flex justify-between">
    <span>
      <span className="font-semibold text-gray-700">Project Name:</span>{" "}
      {customerInfo.project.name}
    </span>
  </div>
)}

    <div className="flex gap-1">
  <span className="font-semibold text-gray-700">Area:</span>

  <span
    className="text-sm text-gray-800 line-clamp-2"
    title={area}
  >
    {area}
  </span>
</div>

    <div className="flex justify-start text-gray-700">
  <span className="font-semibold">City:</span>
  <span className="ml-2 font-normal">{city}</span>
</div>
     <div className="flex justify-between">
  
  {/* LEFT SIDE */}
  <div className="flex gap-1">
    <span className="font-semibold text-gray-700">State:</span>
    <span>{state}</span>
  </div>

  {/* RIGHT SIDE */}
  <div className="flex gap-1">
    <span className="font-semibold text-gray-700">Pincode:</span>
    <span>{pincode}</span>
  </div>

</div>
    </div>
  </div>

</div>

{/* 🔹 RESPONSE SUMMARY BAR */}
{rfqItemResponses?.length > 0 && (() => { 
  const totalItems = rfqItemResponses.length;

  const acceptedItems = new Set(
  suppliers
    ?.flatMap(supplier => supplier?.response_items || [])
    .filter(item => item?.item_status === "Accepted" ||  item?.item_status === "Counter Offer")
    .map(item => item?.requested_item_id)
).size;





  const percentage =
    totalItems > 0
      ? Math.round((acceptedItems / totalItems) * 100)
      : 0;

 return (
  <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-2 w-full ">

    {/* HEADER */}
    <div className="flex items-center justify-between mb-4 px-2">
      <h3 className="text-sm font-semibold text-gray-900">
       Item Response Overview
      </h3>

      <span className="text-xs font-medium text-gray-600 bg-gray-100 px-2 py-1 rounded-md">
        {totalItems} Items
      </span>
    </div>

    {/* ✅ SINGLE SOURCE UI */}
    <div
      // onClick={() => setShowAcceptedPopup(true)}
      className="bg-gray-50 hover:bg-gray-100 transition p-4 rounded-xl "
    >
      {/* Top Row */}
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs text-gray-600 font-medium">
         Response Progress
        </span>

     
  {/* Accepted count → BLUE + UNDERLINE */}
  <span
  onClick={() => setShowAcceptedPopup(true)}
  className="text-sm font-semibold flex items-center gap-1 cursor-pointer group"
>
  {/* ✅ Underline ONLY here */}
  <span className="text-blue-600 underline underline-offset-2 group-hover:text-blue-700 cursor-pointer">
    {acceptedItems}/{totalItems}
  </span>

  {/* ✅ No underline here */}
  <span className="text-blue-600 group-hover:translate-x-1 transition">
    →
  </span>
</span>

      </div>

      {/* Progress */}
      <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden mb-3">
        <div
          className="h-full bg-blue-500 transition-all duration-300"
          style={{ width: `${percentage}%` }}
        />
      </div>

      {/* Bottom Stats (NO REPEAT) */}
      <div className="flex justify-between text-sm">
       
 <span>
  <span className={acceptedItems === totalItems ? "text-green-700 font-semibold" : "text-gray-800 font-semibold"}>
    {acceptedItems}
  </span>

  <span className="text-gray-600"> of </span>

  <span className={acceptedItems === totalItems ? "text-green-700 font-semibold" : "text-gray-800 font-semibold"}>
    {totalItems}
  </span>

  <span className="text-gray-500">
  {" "}
  {totalItems === 1 ? "Item has a response" : "Items have responses"}
</span>
</span>
       <span>
  <span className="text-gray-800 font-medium text-sm">
    {totalItems - acceptedItems}
  </span>
 <span className="text-gray-500 text-sm">
  {" "}
  {(totalItems - acceptedItems) === 1
    ? "Item awaiting a response"
    : "Items awaiting responses"}
</span>
</span>
      </div>
    </div>

  </div>
);

})()}

      {/* ITEMS TABLE */}
{rfqItemResponses?.length > 0 && (
  <div className="bg-white rounded-md border border-gray-200">
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
  <tr className="border-b border-gray-200 uppercase  bg-[#fafafc] text-[#6c7184] text-xs ">
    <th className="px-6 py-4 text-left ">Item Image</th>
    <th className="px-6 py-4 text-left ">Item Name</th>
    <th className="px-6 py-4 text-center">RFQ Price</th>
    <th className="px-6 py-4 text-center ">Quantity</th>
    <th className="px-6 py-4 text-center">Response</th>
    <th className="px-6 py-4 text-left">Final/Best Price</th>
    <th className="px-6 py-4 text-left">Price Given By</th>
  </tr>
</thead>


        <tbody className="divide-y divide-gray-200">
          {rfqItemResponses?.map((item) => (
            <tr key={item.item_id} className="bg-white">
              {/* Item Image */}
              <td className="px-6 py-4">
  {item.item_image ? (
    <img
      src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + item.item_image}
      alt={item.item_name}
      className="w-12 h-12 rounded-md object-cover"
    />
  ) : (
    <div className="w-12 h-12 bg-gray-100 rounded-md flex flex-col items-center justify-center text-xs text-gray-500 leading-tight">
      <span>No</span>
      <span>Image</span>
    </div>
  )}
</td>


              {/* Item Name */}
              <td className="px-6 py-4 text-sm">
                {item.item_name}
              </td>
             
              {/* RFQ Price */}
              <td className="px-6 py-4 text-sm text-center">
                {item.requested_price}
              </td>

              {/* Quantity */}
              <td className="px-6 py-4 text-sm  text-center">
                {item.quantity}
              </td>

              {/* Responses */}
             <td
 className="px-6 py-4 text-sm text-blue-600 cursor-pointer
             underline underline-offset-1
             hover:text-blue-800 hover:decoration-1 text-center"
 onClick={() => {
    openSupplierResponsePopup(item.item_id); 
  }}
>
  {item.response_summary.accepted + item.response_summary.counter_offers}
  /
  {item.response_summary.total_responded}
</td>

              {/* Best Price */}
              <td className="px-6 py-4 text-sm text-center">
                {item.final_price ?? '--'}
              </td>

              {/* Price Given By */}
              <td className="px-6 py-4 text-sm  text-center">
                {item?.best_vendor?.company_name ?? '--'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
)}

{showAcceptedPopup && (
  <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[999] p-4">
    <div className="bg-white w-full max-w-6xl rounded-lg shadow-2xl overflow-hidden flex flex-col max-h-[80vh]">
      
      {/* Header */}
     <div className="flex items-center justify-between px-6 py-2.5 mb-2 mt-2 bg-white">
  <h2 className="text-lg font-medium">
    Item Responses
  </h2>

  <button
    onClick={() => setShowAcceptedPopup(false)}
    className="p-1 rounded-md hover:bg-gray-100 transition"
  >
    <X className="w-4 h-4 text-gray-500 hover:text-gray-700" />
  </button>
</div>

      {/* Table Container */}
<div className="overflow-auto mb-4 flex-1 px-6">
  <div className="mx-auto">
  <table className="w-full border border-gray-200 border-collapse">
            <thead className="sticky top-0 z-30 bg-gray-50 shadow-sm">
            <tr>
              <th className="px-3 py-2 text-sm font-bold text-gray-500 uppercase border-b border-r w-[30%] text-center justify-center">Item Details</th>
              <th className="px-3 py-2 text-sm font-bold text-gray-500 uppercase border-b border-r text-center justify-center">Supplier</th>
              <th className="px-3 py-2 text-sm font-bold text-gray-500 uppercase border-b border-r text-center justify-center">Contact</th>
              <th className="px-3 py-2 text-sm font-bold text-gray-500 uppercase border-b text-center">Status</th>
            </tr>
          </thead>
          
        <tbody className="text-sm border-b mb-2">
  {Object.entries(groupedItemResponses).map(([itemName, itemData], i) => (
    <React.Fragment key={i}>
      
      {itemData.vendors.map((vendor, index) => (
        <tr
          key={index}
          className={`hover:bg-blue-50/30 ${
            index === itemData.vendors.length - 1 ? 'border-b' : ''
          }`}
        >

          {/* ITEM COLUMN with rowSpan */}
          {index === 0 && (
            <td
              rowSpan={itemData.vendors.length}
              className="border-r align-middle"
            >
              <div className="flex items-center justify-start ml-3 h-full gap-2 px-3 py-3 ">
                {itemData.item_image ? (
  <img
    src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + itemData.item_image}
    className="w-10 h-10 rounded border bg-gray-50 object-cover flex-shrink-0"
    alt=""
    onError={(e) => {
      e.target.style.display = "none";
      e.target.nextSibling.style.display = "flex";
    }}
  />
) : null}

{/* Fallback Icon */}
<div
  className="w-10 h-10 rounded border bg-gray-50 flex items-center justify-center flex-shrink-0"
  style={{ display: itemData.item_image ? "none" : "flex" }}
>
  <FontAwesomeIcon icon={faImage} className="text-gray-400 text-md" />
</div>
                <div className="flex flex-col min-w-0">
                  <span className="font-medium text-sm">{itemName}</span>
                  <span className="text-sm mt-1 leading-none">
                    Qty: {vendor.qty} {vendor.uom}
                  </span>
                  <span className="text-sm mt-1 mb-2 leading-none">
                    Price: {vendor.price}
                  </span>
                </div>
              </div>
            </td>
          )}

          {/* SUPPLIER */}
          <td className="border-r text-gray-700 font-medium text-sm align-middle text-center px-3 py-2">
            {vendor.company_name}
          </td>

          {/* CONTACT */}
         <td className="px-3 py-1 border-r align-middle text-center">
  <div
    className="text-blue-600 cursor-pointer hover:underline flex items-center justify-center gap-1 text-sm group"
    onClick={() =>
      setActiveContact(
        activeContact === vendor.mobile_number ? null : vendor.mobile_number
      )
    }
  >
    {/* Mobile Number (unchanged) */}
    {vendor.mobile_number}

    {/* Hover Icons (appear smoothly) */}
    <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition ml-1">

      {/* WhatsApp */}
      <a
        href={`https://wa.me/91${vendor.mobile_number}`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
        className="p-0.5 rounded hover:bg-green-50"
      >
<svg
  className="w-4 h-4 text-green-600"
  viewBox="0 0 24 24"
  fill="currentColor"
>
  <path d="M20.52 3.48A11.91 11.91 0 0 0 12.04 0C5.42 0 .04 5.38.04 12c0 2.11.55 4.16 1.6 5.97L0 24l6.28-1.64A11.94 11.94 0 0 0 12.04 24C18.66 24 24 18.62 24 12c0-3.2-1.25-6.21-3.48-8.52zM12.04 22c-1.87 0-3.7-.5-5.3-1.44l-.38-.23-3.73.98.99-3.63-.25-.37A9.94 9.94 0 0 1 2.04 12c0-5.52 4.48-10 10-10s10 4.48 10 10-4.48 10-10 10zm5.46-7.37c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.34.22-.63.07-.3-.15-1.26-.46-2.4-1.47-.9-.8-1.5-1.78-1.67-2.08-.17-.3-.02-.46.13-.61.13-.13.3-.34.45-.51.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.23-.24-.58-.48-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.02 1-1.02 2.43 0 1.43 1.05 2.81 1.2 3.01.15.2 2.05 3.14 4.98 4.4.7.3 1.25.48 1.68.62.7.22 1.34.19 1.84.12.56-.08 1.76-.72 2.01-1.42.25-.7.25-1.3.17-1.42-.08-.12-.27-.2-.57-.35z"/>
</svg>
     </a>

      {/* Call */}
      <a
        href={`tel:${vendor.mobile_number}`}
        onClick={(e) => e.stopPropagation()}
        className="p-0.5 rounded hover:bg-blue-50"
      >
        <Phone className="w-3.5 h-3.5 text-blue-600" />
      </a>

      {/* Mail */}
      <a
        href={`mailto:${vendor.email || ""}`}
        onClick={(e) => e.stopPropagation()}
        className="p-0.5 rounded hover:bg-red-50"
      >
        <Mail className="w-3.5 h-3.5 text-red-500" />
      </a>

    </div>
  </div>
</td>

          {/* STATUS */}
          <td className="px-3 py-1 align-middle text-center">
            <div className="flex flex-col items-center justify-center">
              <span
  className={`text-sm px-2 py-0.5 rounded-full mt-0.7 ${
    vendor.status === "Accepted"
      ? "text-green-700 bg-green-100 font-semibold"
      : vendor.status === "Respond Now"
      ? "text-yellow-600 font-medium bg-yellow-50"
      : vendor.status === "Expired"
      ? "text-red-700 bg-red-100 font-semibold"
      : "text-gray-600 bg-gray-100"
  }`}
>
  {vendor.status === "Respond Now"
    ? "Waiting for Response"
    : vendor.status}
</span>
            </div>
          </td>

        </tr>
      ))}

    </React.Fragment>
  ))}
</tbody>
        </table>
        </div>
      </div>

    </div>
  </div>
)}

    </div>
  );
}

// STEP 2: SUPPLIER RESPONSES
if (activeStep === 2) {
  return (
    <>
      <div className="flex justify-end mr-4" />
     <div className="rounded-lg overflow-hidden px-4 mb-4">
  {/* Table Container */}
  <div className="overflow-x-auto overflow-y-auto max-h-[30vh]">
    <table className="min-w-full bg-white border border-gray-200 border-collapse">
      {/* Table Header */}
      <thead className="bg-gray-100">
        <tr>
          <th className="px-6 py-3 text-center text-sm font-medium text-gray-900 border border-gray-200">
            Supplier
          </th>
          <th className="px-6 py-3 text-center text-sm font-medium text-gray-900 border border-gray-200">
            Item Responses
          </th>
        </tr>
      </thead>
      
      {/* Table Body */}
      <tbody className="divide-y divide-gray-200">
       {suppliers
  .filter(supplier =>
    supplier?.response_items?.some(item =>
      ["Accepted", "Counter Offer"].includes(item?.item_status)
    )
  )
  .map((supplier, index) => {
    const totalItems = rfqItemResponses.length;

    const acceptedItems = supplier.response_items?.filter(item =>
      ["Accepted", "Counter Offer"].includes(item?.item_status)
    ).length || 0;

            return (
              <tr key={supplier.id || index} className="hover:bg-gray-50">
                <td className="px-6 py-3 text-center whitespace-nowrap text-sm font-medium text-gray-900 border border-gray-200">
                  {supplier.name}
                </td>
                <td className="px-6 py-3 text-center whitespace-nowrap text-sm border border-gray-200">
                  <span className="font-medium text-gray-900">
                    {acceptedItems}/{totalItems}
                  </span>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  </div>
</div>

      <div className="rounded-lg overflow-hidden px-4">
        <div className="overflow-x-auto border max-h-[calc(100vh-300px)]">
          <table className="min-w-full border-collapse text-sm">
            <thead className="bg-gray-100 sticky top-0 z-30">
              <tr>
                <th className="w-[320px] px-5 py-4 text-center border-r font-semibold">
                  Items
                </th>
                <th className="px-5 py-4 text-center border-r font-semibold">
                  Supplier Responses
                </th>
                <th className="px-5 py-4 text-center font-semibold">
                  Selected Response
                </th>
              </tr>
            </thead>

            <tbody>
              {productCategories.map((category) => (
                <React.Fragment key={category.product_category_id}>
                  {/* CATEGORY ROW */}
                  <tr className="bg-gray-50 border-b">
                    <td className="px-5 py-3 font-bold border-r">
                      <div className="flex items-center gap-2">
                        <Layers size={16} />
                        <span>{category.product_category_name}</span>
                        <span className = " text-gray-500 font-regular">({category.items.length})</span>
                      </div>
                    </td>
                    <td className="border-r"></td>
                    <td></td>
                  </tr>

                  {/* ITEMS */}
                  {category.items.map((item) => {
                    // ✅ FIXED: Better alternatives filtering
                    const alternatives = suppliers
                      .flatMap((s) =>
                        s.response_items?.filter(
                          (r) =>
                            r.requested_item_id === item.item_id && 
                            r.item_id !== item.item_id 
                        ) || []
                      )
                      .reduce((acc, cur) => {
                        if (!acc.find((i) => i.item_id === cur.item_id)) {
                          acc.push(cur);
                        }
                        return acc;
                      }, []);

                    const renderRow = (itemData, isAlt = false) => {
                      // ✅ UNIQUE KEY FOR EACH ROW (MAIN vs EACH ALTERNATIVE)
                      const uniqueKey = isAlt 
                        ? `${itemData.item_id}-ALT-${item.item_id}`
                        : `${itemData.item_id}-MAIN`;

                      // ✅ FIXED: Only show suppliers who responded to THIS specific item
                      const validSuppliers = suppliers.filter((supplier) => {
                        const r = supplier.response_items?.find(
                          (x) => x.item_id === itemData.item_id
                        );
                        return (
                          r &&
                          (supplier.status === "Accepted" ||
                            supplier.status === "Counter Offer")
                        );
                      });

                      // ✅ LOWEST PRICE BEST SUPPLIER
                      const bestSupplier = validSuppliers.reduce((best, supplier) => {
                        const r = supplier.response_items?.find(
                          (x) => x.item_id === itemData.item_id
                        );
                        const unit = r?.proposed_price > 0 ? r.proposed_price : r?.requested_price;
                        const total = unit && itemData.quantity ? unit * itemData.quantity : Infinity;
                        
                        if (!best || total < best.total) {
                          return { vendor_id: supplier.vendor_id, total, unit };
                        }
                        return best;
                      }, null);

                      return (
                        <tr
                          key={`${itemData.item_id}-${isAlt ? 'alt' : 'main'}`}
                          className={`border-b ${isAlt ? "bg-green-50/60" : ""}`}
                        >
                          {/* ITEM */}
                          <td className={`px-5 py-3 border-r align-top ${
                            isAlt ? "pl-10 border-l-4 border-green-400" : ""
                          }`}>
                            <div className="flex gap-3 items-start">
                              {itemData.item_image ? (
  <img
    src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + itemData.item_image}
    className="w-11 h-11 rounded object-cover"
    alt={itemData.item_name}
  />
) : (
  <FontAwesomeIcon 
    icon={faImage} 
    className="w-11 h-11 text-gray-400" 
  />
)}
                              <div>
                                <div className="font-semibold text-gray-800">
                                  {itemData.item_name}
                                </div>
                                <div className="text-xs text-gray-500">
                                  Qty {itemData.quantity} • {itemData.UOM}
                                </div>
                                <div className="text-sm font-semibold text-gray-700 mt-1">
                                  ₹ {itemData.selling_price || "-"}
                                </div>
                              </div>
                            </div>
                          </td>

                          {/* SUPPLIERS */}
                         <td className="px-5 py-3 border-r align-top">
  <div className="flex flex-col items-center text-center max-h-[150px] overflow-y-auto pr-2">
    {validSuppliers.length === 0 ? (
      <div className="text-xs text-gray-400">No Supplier Responded</div>
    ) : (
      validSuppliers.map((supplier) => {
        const r = supplier.response_items?.find((x) => x.item_id === itemData.item_id);
        if (!r) return null;

        const unit = r?.proposed_price > 0 ? r.proposed_price : r?.requested_price;
        const total = unit && itemData.quantity ? unit * itemData.quantity : null;

        return (
          <div key={`${uniqueKey}-${supplier.vendor_id}`} className="mb-3 flex flex-col items-center">
          {/* YOUR EXACT SECTION - ONLY input replace chey */}
<label className="flex items-center gap-2 cursor-pointer">
  {isAlt ? (
    /* ✅ ALTERNATIVES ONLY - Custom toggle */
    <div 
      className={`w-4 h-4 border-2 rounded-full flex items-center justify-center cursor-pointer transition-all group relative ${
        selection[uniqueKey]?.vendor_id === supplier.vendor_id
          ? 'border-blue-500 bg-blue-500 shadow-sm'
          : 'border-gray-300 hover:border-blue-400 hover:shadow-md'
      }`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setSelection((prevSelection) => {
          const currentSelectedVendorId = prevSelection[uniqueKey]?.vendor_id;
          
          if (currentSelectedVendorId === supplier.vendor_id) {
            // DESELECT
            const newSelection = { ...prevSelection };
            delete newSelection[uniqueKey];
            return newSelection;
          } else {
            // SELECT
            return {
              ...prevSelection,
              [uniqueKey]: {
                vendor_id: supplier.vendor_id,
                supplierName: supplier.company_name || supplier.name,
                unit,
                total,
                isAlternative: isAlt,
                item_name: itemData.item_name,
                quantity: itemData.quantity
              }
            };
          }
        });
      }}
    >
      {selection[uniqueKey]?.vendor_id === supplier.vendor_id && (
        <div className="w-2 h-2 bg-white rounded-full shadow-inner"></div>
      )}
    </div>
  ) : (
    /* ✅ MAIN ITEMS - Original radio (no deselect) */
    <input
      type="radio"
      name={`radio-group-${uniqueKey}`}
      checked={selection[uniqueKey]?.vendor_id === supplier.vendor_id}
      onChange={() => {
        setSelection((prev) => ({
          ...prev,
          [uniqueKey]: {
            vendor_id: supplier.vendor_id,
            supplierName: supplier.company_name || supplier.name,
            unit,
            total,
            isAlternative: isAlt,
            item_name: itemData.item_name,
            quantity: itemData.quantity
          }
        }));
      }}
      className="w-4 h-4 accent-blue-600 cursor-pointer"
    />
  )}
  
  <span className="text-sm text-gray-700 font-medium">
    {supplier.company_name || supplier.name}
  </span>
</label>
            <div className="text-xs text-gray-500 mt-1">
              ₹{unit} × {itemData.quantity} = ₹{total?.toLocaleString()}
            </div>
          </div>
        );
      })
    )}
  </div>
</td>

                          {/* SELECTED */}
                          <td className="px-5 py-3 align-top">
                            <div className="flex flex-col items-center justify-center w-full text-center min-h-[60px]">
                              {(() => {
                                const selected = selection[uniqueKey];
                                if (!selected) {
                                  return (
                                    <span className="text-gray-400 text-xs">Not Selected</span>
                                  );
                                }
                                return (
                                  <div className="flex flex-col gap-2 items-center">
                                    <div className="flex items-center gap-1 bg-blue-50 text-blue-700 text-sm px-2 py-1 rounded-md">
                                      <CheckCircle2 size={16} className="text-blue-600" />
                                      {selected.supplierName}
                                    </div>
                                    
                                    <div className="text-xs text-gray-500">
                                      ₹{selected.unit} × {itemData.quantity}
                                    </div>
                                    
                                   <div className="relative flex justify-center items-center">
  {/* Centered price */}
  <div className="text-sm font-semibold text-blue-700">
    ₹{selected.total?.toLocaleString()}
  </div>

  {/* Best badge */}
 {bestSupplier?.vendor_id === selected?.vendor_id && (
    <div className="absolute left-1/2 translate-x-6 text-xs text-green-600 font-bold bg-green-100 px-2 py-0.5 rounded-full">
      Best
    </div>
  )}
</div>


                                  </div>
                                );
                              })()}
                            </div>
                          </td>
                        </tr>
                      );
                    };

                    return (
                      <React.Fragment key={item.item_id}>
                        {/* MAIN ITEM */}
                        {renderRow(item, false)}

                        {/* ALTERNATIVES */}
{alternatives.length > 0 && (
  <>
    {/* ✅ HEADER - CLICKABLE */}
    <tr 
      className="bg-green-50 border-b cursor-pointer hover:bg-green-100 transition-colors"
      onClick={() => toggleAlternatives(category.product_category_id, item.item_id)}
    >
      <td className="px-5 py-3 text-green-700 font-semibold border-r">
        <div className="flex items-center gap-2">
          {/* ✅ CHEVRON ICONS */}
          <FontAwesomeIcon 
            icon={collapsedAlternatives[`${category.product_category_id}-${item.item_id}`] ? faChevronDown : faChevronUp}
            className="w-3 h-3 text-green-600 transition-transform duration-200"
          />
          <span>Alternatives ({alternatives.length})</span>
        </div>
      </td>
      <td className="border-r"></td>
      <td></td>
    </tr>

    {/* ✅ CONTENT - SHOW/HIDE */}
   {collapsedAlternatives[`${category.product_category_id}-${item.item_id}`] !== true && 
  alternatives.map((alt) => renderRow(alt, true))
}
  </>
)}
                      </React.Fragment>
                    );
                  })}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>

     {/* SUMMARY - FIXED: MAIN ITEMS ONLY */}
<div className="flex justify-end mt-4 mx-4">
  <div className="bg-white p-4 rounded-lg shadow border w-80">
    <h4 className="text-lg font-semibold text-gray-800 mb-3">Summary</h4>
    <div className="space-y-2">
      {(() => {
        // ✅ ONLY MAIN ITEMS (keys ending with "-MAIN")
        const mainSelections = Object.entries(selection).filter(([key]) => 
          key.endsWith('-MAIN')
        );
        
        const itemsTotal = mainSelections.reduce(
          (total, [, sel]) => total + (sel?.total || 0),
          0
        );
        const selectedCount = mainSelections.length;
        
        return (
          <>
            <div className="flex justify-between">
              <span className="text-sm text-gray-600">
                Total
              </span>
              <span className="font-medium">₹{itemsTotal.toLocaleString()}</span>
            </div>
            <div className="flex justify-between border-t pt-2">
              <span className="text-sm font-semibold text-gray-800">Grand Total:</span>
              <span className="font-bold text-lg text-blue-600">
                ₹{itemsTotal.toLocaleString()}
              </span>
            </div>
          </>
        );
      })()}
    </div>
  </div>
</div>
    </>
  );
}
  // STEP 3: DELIVERY SHIPMENTS (YOUR UI)
// 🔥 STEP 3 UI
// 🔥 STEP 3 UI - UPDATED
if (activeStep === 3) {
  return (
    <div className="p-4 space-y-4">

    {confirmDeleteOpen && (
  <div className="fixed inset-0 bg-black/40 flex items-start justify-center z-[50]">
    <div className="bg-white rounded-lg p-6 w-80 shadow-lg text-center relative">
      
      {/* 🔴 Top-right close button */}
     <button
  onClick={() => {
    setConfirmDeleteOpen(false);
    setGroupToDeleteIndex(null);
  }}
  className="absolute top-3 right-3 w-6 h-6 flex items-center justify-center rounded-full bg-gray-200 hover:bg-gray-300"
>
  <FontAwesomeIcon icon={faTimes} className="text-gray-600 text-xs" />
</button>

      <p className="text-md text-gray-900 text-center mt-4">
        If you delete this group, all items will be moved to <b>DG-1</b>.
      </p>

      <div className="flex justify-center gap-4 mt-6">
        <button
          className="px-6 py-1.5 text-sm rounded-md font-medium border"
          onClick={() => {
            setConfirmDeleteOpen(false);
            setGroupToDeleteIndex(null);
          }}
        >
          Cancel
        </button>

        <button
          className="px-6 py-1.5 text-sm rounded-md font-medium bg-red-600 text-white hover:bg-red-700"
          onClick={() => {
  
  handleDeleteGroup(groupToDeleteIndex);
  setConfirmDeleteOpen(false);
  setGroupToDeleteIndex(null);
  
  // 🔥 FORCE SUCCESS POPUP
  toast.success("Delivery group deleted successfully");
          }}
        >
          Delete
        </button>
      </div>

    </div>
  </div>
)}

      {groups.map((group, index) => {
        const totalWeight = groupWeight(group.suppliers);
        const isLatestGroup = index === groups.length - 1;

        return (
          <div key={group.groupId} data-group-id={group.groupId} className="border rounded-xl bg-white shadow-sm">
            
            {/* HEADER - REORGANIZED */}
            <div className="flex justify-between items-center px-4 py-3 bg-gray-50 border-b">
              <div>
                <h3 className="font-semibold">
                  Delivery Group (DG-{index + 1})
                  {/* + ADD BUTTON ONLY FOR LATEST GROUP */}
                  {isLatestGroup && (
                    <button
                      onClick={addGroup}
                      className="ml-3 text-blue-600 text-sm p-1 font-medium hover:bg-blue-50 rounded px-2"
                    >
                      + Add Delivery Group
                    </button>
                  )}
                </h3>
              </div>

              {/* RIGHT SIDE: DROPDOWN + DELETE */}
              <div className="flex items-center gap-3">
                {/* DROPDOWN - MOVED TO RIGHT */}
                <div className="flex items-center gap-2 text-sm">
                  <label className="text-xs text-gray-500 whitespace-nowrap">
                    Delivered By Brickbucket?
                  </label>
                  <select
                    className="border rounded px-2 py-1 text-sm bg-white"
                    value={group.deliveredByBrickbucket || "false"}
                    onChange={(e) => {
                      const updated = [...groups];
                      updated[index].deliveredByBrickbucket = e.target.value;
                      setGroups(updated);
                    }}
                  >
                    <option value="false">No (Self Delivery)</option>
                    <option value="true">Yes (3PL)</option>
                  </select>
                </div>

                {/* DELETE BUTTON */}
                <button
                 onClick={() => {

  if (groups.length === 1) {
    setPopupType("400");
    setPopupMessage("DG-1 is the default delivery group and cannot be deleted.");
    setShowPopupMessages(true);
    return;
  }

  setGroupToDeleteIndex(index);
  setConfirmDeleteOpen(true);
return;  // Add this
}}

                  className="p-1 rounded-full hover:bg-red-50"
                >
                  <span className="text-gray-400 hover:text-red-500 text-lg">
                    <FontAwesomeIcon icon={faTrash} className="text-gray-500 w-4 h-4" />
                  </span>
                </button>
              </div>
            </div>

            {/* BODY - REMAINS SAME */}
            <div className={`grid ${group.deliveredByBrickbucket === "true" ? "grid-cols-2" : "grid-cols-1"}`}>
              {/* LEFT SIDE */}
              <div className="p-4 space-y-4">
                {Object.values(group.suppliers).map((supplier, i) => (
                  <div key={i}>
                    <h4 className="font-semibold mb-2">
                      {supplier.supplierName}
                    </h4>

                    <table className="w-full text-sm border rounded">
                      <thead className="bg-gray-100 text-xs">
                        <tr>
                          <th className="text-left px-2 py-2">Item</th> 
                          <th className="text-center px-2 py-2">Qty</th>
                          <th className="text-center px-2 py-2">Weight (per unit)</th>
                          <th className="text-center px-2 py-2">Dimensions (per unit)</th>
                          <th className="text-center px-2 py-2">Move</th>
                        </tr>
                      </thead>

                      <tbody>
                        {supplier.items.map((item, idx) => (
                          <tr key={idx} className="border-t">
                            <td className="px-2 py-2">{item?.item_name}</td>
                            <td className="text-center">{item?.quantity}</td>
                            <td className="text-center">{item?.weight?.value || "--"} {item?.weight?.unit}</td>
                            <td className="text-center">
                              {item?.dimensions?.length}×{item?.dimensions?.width}×{item?.dimensions?.height} {item?.dimensions?.unit}
                            </td>
                            <td className="text-center">
                              <select
  className="border rounded px-1 py-1 text-xs"
  value=""
  onChange={(e) => {
    moveItemToGroup(item, group.groupId, e.target.value);

    // 👇 RESET dropdown immediately
    e.target.value = "";
  }}
>
                                <option value="" disabled>
                                  Move
                                </option>
                                {groups
                                  .filter(g => g.groupId !== group.groupId)
                                  .sort((a, b) => a.groupId.localeCompare(b.groupId))
                                  .map((g, filteredIndex) => {
                                    const baseIndex = groups.findIndex(group => group.groupId === g.groupId);
                                    const displayIndex = baseIndex + 1;
                                    const itemCount = Object.values(g.suppliers || {}).reduce((acc, s) => acc + (s.items?.length || 0), 0);
                                    
                                    return (
                                      <option key={g.groupId} value={g.groupId}>
                                        DG-{displayIndex} ({itemCount} items)
                                      </option>
                                    );
                                  })}
                              </select>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ))}
              </div>

              {/* RIGHT SIDE - SAME */}
              {group.deliveredByBrickbucket === "true" && (
                <div className="border-l p-4 bg-gray-50 space-y-4">
                  {fareLoading && (
                    <div className="flex items-center justify-center py-4 bg-blue-50 rounded-lg border">
                      <div className="flex space-x-2 mr-2">
                        <div className="w-3 h-3 bg-blue-500 rounded-full animate-bounce" style={{animationDelay: '0s'}} />
                        <div className="w-3 h-3 bg-blue-500 rounded-full animate-bounce" style={{animationDelay: '0.1s'}} />
                        <div className="w-3 h-3 bg-blue-500 rounded-full animate-bounce" style={{animationDelay: '0.2s'}} />
                      </div>
                      <span className="text-sm font-medium text-blue-700">Calculating fare...</span>
                    </div>
                  )}

                  <div className="text-xs inline-block px-2 py-1 rounded-full font-semibold uppercase tracking-wide">
                    {(() => {
                      const supplierCount = Object.keys(group.suppliers || {}).length;
                      if (supplierCount > 1) {
                        return <span className="bg-orange-100 text-orange-800">Multi-stop ({supplierCount})</span>;
                      } else if (supplierCount === 1) {
                        return <span className="bg-green-100 text-green-800">Single-stop</span>;
                      } else {
                        return <span className="bg-gray-100 text-gray-700">No suppliers</span>;
                      }
                    })()}
                  </div>

                  <div className="text-sm text-gray-600 leading-relaxed">
                    {(() => {
                      const supplierCount = Object.keys(group.suppliers || {}).length;
                      const supplierNames = Object.values(group.suppliers || {}).map(s => s.supplierName);
                      
                      if (supplierCount > 1) {
                        return (
                          <>
                            <div>{supplierCount} pickups → 1 delivery</div>
                            <div className="text-xs mt-1 bg-gray-50 p-2 rounded-md font-medium">
                              {supplierNames.slice(0, 2).join(", ")}
                              {supplierCount > 2 && ` +${supplierCount - 2} more`}
                            </div>
                          </>
                        );
                      } else if (supplierCount === 1) {
                        return `Pickup from ${supplierNames[0]} → Delivery`;
                      } else {
                        return "Add suppliers to enable delivery";
                      }
                    })()}
                  </div>

                  <div className="text-sm space-y-1">
                    <div className="flex justify-between">
                      <span className="text-gray-500">Est. Distance</span>
                      <span className="font-semibold">{group.distance || "--"} km</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-500">Total Weight</span>
                      <span className="font-semibold">{group.totalWeight || "--"} kg</span>
                    </div>
                  </div>

    <div className="space-y-2">
       {vehicleLoadingGroup === group.groupId ? (
    <div className="flex justify-center py-4">
      <div className="flex space-x-2">
        <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"></div>
        <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: "0.1s" }}></div>
        <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: "0.2s" }}></div>
      </div>
    </div>
  ) : (
    group.vehicles
      ?.filter((v) => {
        if (group.showAllVehicles) return true;
        if (group.vehicleId) return v.id === group.vehicleId;
        return v.recommended;
      })
      .map((v) => (
      <div
        key={v.id}
     onClick={() => {
  // prevent multiple clicks
  if (vehicleLoadingGroup === group.groupId) return;

  // 👉 show loader
  setVehicleLoadingGroup(group.groupId);

  setTimeout(() => {
    setGroups(prev => {
      return prev.map((g, i) => {
        if (g.groupId !== group.groupId) return g;

        // ✅ USE LATEST STATE (g), NOT group
        if (!g.showAllVehicles) {
          return {
            ...g,
            showAllVehicles: true
          };
        } else {
          return {
            ...g,
            vehicleId: v.id,
            deliveryCharge: v.customerFare,
            showAllVehicles: false
          };
        }
      });
    });

    // 👉 stop loader
    setVehicleLoadingGroup(null);

  }, 500);
}}


        className={`p-3 rounded-xl border cursor-pointer transition-all
          ${group.vehicleId === v.id
            ? "border-blue-500 bg-blue-50 shadow-sm"
            : "border-gray-200 hover:border-gray-300"}
        `}
      >
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            <span className="text-lg">{v.icon}</span>
            <div>
              <div className="flex items-center gap-2 font-medium text-sm">
              <span>{v.tag}</span>

            {!group.showAllVehicles && (
            <ChevronDown size={20} className="text-gray-600 font-medium" />
            )}

             {group.showAllVehicles && group.vehicleId === v.id && (
              <ChevronUp size={20} className="text-gray-600 font-medium" />
               )}
        </div>
              {v.recommended && (
                <div className="text-xs text-blue-600">
                  ★ Recommended
                </div>
              )}
            </div>
          </div>
          <div className="text-right">
            <div className="font-semibold">₹{v.customerFare}</div>
            <div className="text-xs text-gray-500">
              Max {v.capacityKg} kg
            </div>
          </div>
        </div>
      </div>
      
    ))
  )}

</div>

                  <div className="border-t pt-3 flex justify-between">
                    <span className="text-gray-600">
                      Customer delivery
                    </span>
                   {(!group.vehicles?.length || !group.totalWeight) ? (

  <div className="flex items-center justify-center border border-gray-300 rounded px-2 py-1 w-18">
  <input
    type="text"
    inputMode="numeric"
    placeholder="₹ 0"
    value={group.deliveryCharge ? `₹ ${group.deliveryCharge}` : ""}
    onChange={(e) => {
      const value = e.target.value.replace(/[^0-9]/g, "");
      const updated = [...groups];
      updated[index].deliveryCharge = value;
      setGroups(updated);
    }}
    className="w-20 text-center text-sm outline-none"
  />
</div>


) : (

  <span className="font-semibold">
    ₹{group.deliveryCharge || 0}
  </span>

)}

                  </div>
                </div>
              )}
            </div>
          </div>
        );
      })}


    </div>
  );
}

  // STEP 4: AWARDED
  if (activeStep === 4) {
  return (
    <div className="bg-white mx-1 rounded-xl p-2 space-y-8">
      
      {/* SUPPLIER CARDS - MAPPED FROM DATA */}
    {/*  <div className="space-y-6">   
  {awardsData.map((award, index) => (
    <div 
      key={award.id}
      className="mx-1 bg-gradient-to-br from-slate-50 to-gray-50 rounded-xl p-6 border border-gray-200  transition-all duration-200"
    >
      
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center">
          <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center mr-3 shadow-md flex-shrink-0">
           <svg
  className="w-5 h-5 text-gray-600"
  fill="none"
  stroke="currentColor"
  strokeWidth="1.7"
  viewBox="0 0 24 24"
>
  <path
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M3 22h18M6 22V4h4v18M14 22V8h4v14"
  />
</svg>
          </div>
          <div>
            <h3 className="text-lg font-bold text-gray-900">{award.companyName}</h3>
            <p className="text-sm text-gray-600 mt-1">{award.contactPerson}</p>
          </div>
        </div>
        <span className={`inline-flex items-center px-3 py-1 text-xs font-bold rounded-full shadow-sm ${
          award.isAwarded 
            ? "bg-emerald-100 text-emerald-800" 
            : "bg-gray-100 text-gray-600"
        }`}>
          {award.isAwarded ? " Awarded" : " Not Awarded"}
        </span>
      </div>
      
    
<div className="grid grid-cols-3 gap-4 text-sm mb-4 items-center ml-12">
 
  <div className="flex items-center">
    <svg
      className="w-4 h-4 text-gray-500 mr-1.5"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
      />
    </svg>
    <span className="font-medium text-gray-900">{award.phone}</span>
  </div>

 
  <div className="flex items-center">
    <svg
      className="w-4 h-4 text-gray-500 mr-1.5"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </svg>
    <span className="font-medium text-gray-900">{award.location}</span>
  </div>


  <div className="flex items-center gap-2">

  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
    <FontAwesomeIcon icon={faTruck} className="text-gray-500 w-5 h-5" />
  </div>
  
  <span className="font-medium text-gray-900 whitespace-nowrap">
    {award.Type}
  </span>
</div>
</div>


      
   <div className="flex items-center justify-between pt-3 border-t border-gray-200 text-sm ml-12">
 
  <a
    href="#"
    className="flex items-center text-emerald-600 hover:text-emerald-700 font-medium underline underline-offset-2"
  >
    <svg
      className="w-4 h-4 mr-1.5"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
      />
    </svg>
    {award.itemsCount} Items
  </a>


  <span className="font-bold text-lg text-emerald-600">
    ₹{award.amount.toLocaleString()}
  </span>

  
  <div className="flex items-center text-gray-500">
    <svg
      className="w-3.5 h-3.5 mr-1"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
    Requested {award.requestDate} {award.requestTime}
  </div>
</div>


    </div>
  ))}
</div> */}

     <div className="overflow-x-auto">
                <table className="min-w-full border rounded-lg">
                  <thead className="bg-[#fafafc] text-[#6c7184] text-xs uppercase">
                    <tr className='border-b'>
                      <th className="px-4 py-3 text-left">Item Image</th>
                      <th className="px-4 py-3 text-left">Item Name</th>
                      <th className="px-4 py-3 text-center">Req. Price</th>
                      <th className="px-4 py-3 text-center">Response</th>
                      <th className="px-4 py-3 text-center">Final / Best Price</th>
                      <th className="px-4 py-3 text-center">Price Given By</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    {/* {console.log("rfqItemResponses:::",rfqItemResponses)} */}
                   {rfqItemResponses
                   .filter(item => item?.awarded_vendor && item.awarded_vendor !== "Not Available")
                   .map((item, index) => {
                      const summary = item?.response_summary || {};
                      const accepted = summary?.accepted || 0;
                      const counter = summary?.counter_offers || 0;
                      const total = summary?.total_responded || 0;
                      const finalPrice =
                        item?.final_price && item.final_price !== "--"
                          ? `₹${item.final_price}`
                          : item?.best_vendor?.proposed_price
                          ? `Best ₹${item?.best_vendor?.proposed_price}`
                          : "--";

                      return (
                        <tr key={index} >
                         <td className="px-4 py-3">
  {item?.item_image ? (
    <img
      src={imageurl + item?.item_image}
      alt={item?.item_name || "Item"}
      className="w-12 h-12 object-cover rounded-md border"
    />
  ) : (
    <div className="w-12 h-12 bg-gray-100 flex flex-col items-center justify-center rounded-md text-xs text-gray-500 leading-tight">
      <span>No</span>
      <span>Image</span>
    </div>
  )}
</td>

                          <td className="px-4 py-3 text-sm">{item?.item_name || "--"}</td>
                          <td className="px-4 py-3 text-sm text-center">₹{formatAmount(item?.requested_price || 0)}</td>
                          <td className="px-4 py-3 text-center text-sm">
                            {accepted + counter}/{total}
                          </td>
                          <td className="px-4 py-3 text-center text-sm">{finalPrice}</td>
                          <td className="px-4 py-3 text-center text-sm">
                            {item?.awarded_vendor || "Not Available"}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

      {/* PRICING SUMMARY - MAPPED FROM DATA */}
     <div className="mx-1 bg-gradient-to-br from-slate-50 to-gray-50 rounded-xl p-6 border border-gray-200">   
  <h3 className="text-xl font-bold text-gray-900 mb-4">Pricing Summary</h3>
  
  <div className="flex items-end space-x-8 mb-4 text-sm border-b border-gray-200 pb-3">
    <div className="flex-1">
      <span>Subtotal: ₹{formatAmount(customerInfo?.pricing_summary?.final?.subtotal || 0)}</span>
    </div>
    <div className="flex-1">
      <span>Tax Amount: ₹{formatAmount(customerInfo?.pricing_summary?.final?.tax_amount || 0)}</span>
    </div>
    <div className="flex-1">
      <span>Delivery Charge: ₹{formatAmount(finalRfqData?.delivery_charges || 0 )}</span>
    </div>
    <div className="flex-1">
      <span className="font-bold text-lg">Total: ₹{formatAmount(customerInfo?.pricing_summary?.final?.total || 0)}</span>
    </div>
  </div>
  
  <div className="flex items-center justify-between p-3 bg-blue-50 rounded-xl border border-blue-100 text-xs">
   <span className="font-semibold">Buildcoins Discount: <span className="font-bold">-₹{formatAmount(customerInfo?.pricing_summary?.final?.buildcoins_discount || 0)}</span></span>
    <button 
  className="bg-blue-600 text-white px-6 py-2 rounded-lg font-semibold text-sm hover:bg-blue-700 transition-all duration-200"
  onClick={() => setShowPopup(true)}
>
  Give Buildcoins
</button>
  </div>
</div>


    </div>
  );
}

 // STEP 5: CUSTOMER PAYMENTS (NEW DESIGN)
if (activeStep === 5) {
  return (
    <div className="bg-white mx-1 rounded-xl  p-2 space-y-8 ">
      
      {/* CUSTOMER INFORMATION CARD */}
     <div className="mx-1 bg-gradient-to-br from-slate-50 via-blue-25 to-indigo-25 rounded-xl p-6 border border-blue-100  transition-all duration-200">
  
  <div className="flex items-center mb-5">
    <div className="w-8 h-8 bg-blue-400 rounded-lg flex items-center justify-center mr-3 shadow-md flex-shrink-0">
      <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
      </svg>
    </div>

    <h3 className="text-lg font-semibold text-gray-900">
      Customer Information
    </h3>
  </div>



  
  {/* CUSTOMER DETAILS - SAME LINE LAYOUT */}
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 text-sm">
    <div className="space-y-1.5">
      <p className="font-semibold text-gray-600 uppercase tracking-wide text-xs">Company Name</p>
      <p className="font-bold text-md text-gray-900">{customerInfo?.customer?.company_name || '---'}</p>
    </div>
    <div className="space-y-1.5">
      <p className="font-semibold text-gray-600 uppercase tracking-wide text-xs">Customer Name</p>
      <p className="font-bold text-md text-gray-900">{customerInfo?.customer_name || customerInfo?.customer?.name }</p>
    </div>
    <div className="space-y-1.5">
      <p className="font-semibold text-gray-600 uppercase tracking-wide text-xs">Email</p>
      <p className="font-bold text-md text-blue-600 break-all">{customerInfo?.customer?.email || ''}</p>
    </div>
    <div className="space-y-1.5">
      <p className="font-semibold text-gray-600 uppercase tracking-wide text-xs">Phone</p>
      <p className="font-bold text-md text-gray-900">{customerInfo?.customer?.mobile || ''}</p>
    </div>
    <div className="space-y-1.5">
      <p className="font-semibold text-gray-600 uppercase tracking-wide text-xs">Amount</p>
      <p className="font-bold text-md text-gray-900">{customerInfo?.pricing_summary?.final?.total || 0}</p>
    </div>
  </div>
</div>


   {/* PAYMENT SECTION */}
{paymentDetails ? (
  /* ================= PAYMENT DETAILS (READ ONLY) ================= */
  <div className="mx-1 bg-gradient-to-br from-emerald-50 to-green-50 rounded-xl p-6 border border-emerald-200 transition-all duration-200">
    <div className="flex items-start mb-8">
      <div className="w-10 h-10 bg-emerald-500 rounded-2xl flex items-center justify-center mr-5 shadow-lg">
        <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
        </svg>
      </div>
      <div>
        <h3 className="text-lg font-semibold text-gray-900">Payment Details</h3>
        <p className="text-emerald-600 font-semibold text-sm">Successfully Processed</p>
      </div>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6 p-6 bg-white/50 rounded-2xl">
      <div>
        <p className="text-sm font-semibold text-gray-700">Date</p>
        <p className="text-sm font-bold text-gray-900">
          {new Date(paymentDetails.payment_date).toLocaleDateString()}
        </p>
      </div>

      <div>
        <p className="text-sm font-semibold text-gray-700">Amount</p>
        <p className="text-sm font-black text-emerald-600">
          ₹ {(paymentDetails.amount)}
        </p>
      </div>

      <div>
        <p className="text-sm font-semibold text-gray-700">Payment Method</p>
        <span className="inline-flex px-3 py-1 bg-emerald-100 text-emerald-800 text-sm font-bold rounded-full">
          {paymentDetails.payment_mode}
        </span>
      </div>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-6 bg-white/50 rounded-2xl">
      <div>
        <p className="text-xs font-semibold uppercase text-gray-600">Transaction ID</p>
        <p className="text-sm font-medium text-gray-900">
          {paymentDetails?.upi_details?.transaction_id ||
           paymentDetails?.card_details?.transaction_id ||
           paymentDetails?.bank_transfer_details?.transaction_reference ||
           "-"}
        </p>
      </div>

      <div className="text-center">
        <p className="text-xs font-semibold uppercase text-gray-600">Status</p>
        <span className="inline-flex px-3 py-1 bg-emerald-100 text-emerald-800 text-sm font-bold rounded-full">
          {paymentDetails.status || "Paid"}
        </span>
      </div>
    </div>
  </div>
) : (
  /* ================= CREATE PAYMENT FORM ================= */
   <div className="mx-1 bg-white rounded-xl p-6 border border-gray-200">
    <h3 className="text-lg font-semibold mb-4">Create Payment</h3>

    {/* BASIC DETAILS */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
      <input type="date" className="border p-2 rounded"
        value={paymentDate} onChange={e => setPaymentDate(e.target.value)} />

      <select className="border p-2 rounded"
        value={paymentMode} onChange={e => setPaymentMode(e.target.value)}>
        <option value="">Select Payment Mode</option>
        <option>Cash</option>
        <option>UPI</option>
        <option>Card</option>
        <option>Bank Transfer</option>
        <option>Cheque</option>
        <option>Gateway</option>
      </select>

     <input
  type="text"
  placeholder="Amount"
  className="border p-2 rounded"
  value={`₹ ${formatAmount(amount)}`}
  onChange={(e) => {
    const rawValue = e.target.value
      .replace(/₹\s?/g, "") 
      .replace(/,/g, "");  

    if (!isNaN(rawValue)) {
      setAmount(rawValue);
    }
  }}
/>
    </div>

    {/* CASH */}
    {paymentMode === "Cash" && (
      <p className="text-sm text-gray-600 mb-4">
        Cash payment received directly from customer.
      </p>
    )}

    {/* UPI */}
    {paymentMode === "UPI" && (
      <div className="grid md:grid-cols-3 gap-4 mb-4">
        <input placeholder="UPI ID" className="border p-2 rounded"
          onChange={e => setUpiDetails({ ...upiDetails, upi_id: e.target.value })} />
        <input placeholder="Transaction ID" className="border p-2 rounded"
          onChange={e => setUpiDetails({ ...upiDetails, transaction_id: e.target.value })} />
        <input placeholder="Payer Name" className="border p-2 rounded"
          onChange={e => setUpiDetails({ ...upiDetails, payer_name: e.target.value })} />
      </div>
    )}

    {/* CARD */}
    {paymentMode === "Card" && (
      <div className="grid md:grid-cols-3 gap-4 mb-4">
        <input placeholder="Card Type" className="border p-2 rounded"
          onChange={e => setCardDetails({ ...cardDetails, card_type: e.target.value })} />
        <input placeholder="Last 4 Digits" className="border p-2 rounded"
          onChange={e => setCardDetails({ ...cardDetails, last_four_digits: e.target.value })} />
        <input placeholder="Transaction ID" className="border p-2 rounded"
          onChange={e => setCardDetails({ ...cardDetails, transaction_id: e.target.value })} />
      </div>
    )}

    {/* BANK / CHEQUE */}
    {["Bank Transfer", "Cheque"].includes(paymentMode) && (
      <div className="grid md:grid-cols-2 gap-4 mb-4">
        <input placeholder="From Account" className="border p-2 rounded"
          onChange={e => setBankDetails({ ...bankDetails, from_account: e.target.value })} />
        <input placeholder="To Account" className="border p-2 rounded"
          onChange={e => setBankDetails({ ...bankDetails, to_account: e.target.value })} />
        <input placeholder="IFSC Code" className="border p-2 rounded"
          onChange={e => setBankDetails({ ...bankDetails, ifsc_code: e.target.value })} />
        <input placeholder="Transaction / Cheque No" className="border p-2 rounded"
          onChange={e => setBankDetails({ ...bankDetails, transaction_reference: e.target.value })} />
      </div>
    )}

    {/* GATEWAY */}
    {paymentMode === "Gateway" && (
      <div className="grid md:grid-cols-2 gap-4 mb-4">
        <input placeholder="Gateway Name" className="border p-2 rounded"
          onChange={e => setGatewayDetails({ ...gatewayDetails, gateway_name: e.target.value })} />
        <input placeholder="Gateway Transaction ID" className="border p-2 rounded"
          onChange={e => setGatewayDetails({ ...gatewayDetails, gateway_transaction_id: e.target.value })} />
        <input placeholder="Payment ID" className="border p-2 rounded"
          onChange={e => setGatewayDetails({ ...gatewayDetails, gateway_payment_id: e.target.value })} />
        <input placeholder="Order ID" className="border p-2 rounded"
          onChange={e => setGatewayDetails({ ...gatewayDetails, gateway_order_id: e.target.value })} />
      </div>
    )}

    {/* DESCRIPTION */}
    <textarea rows={3} className="border w-full p-2 rounded mb-4"
      placeholder="Payment description"
      value={description} onChange={e => setDescription(e.target.value)} />

    {/* ACTIONS */}
    <div className="flex justify-end gap-3">
      <button className="border px-4 py-2 rounded">Cancel</button>
      <button disabled={loading}
        onClick={handleSavePayment}
        className="bg-emerald-600 text-white px-5 py-2 rounded">
        {loading ? "Saving..." : "Save Payment"}
      </button>
    </div>
  </div>
)}

    

    </div>
    
  );
}


// STEP 6: ORDER PLACED
if (activeStep === 6 && finalRfqData) {
  return (
    <div className="p-4 space-y-6">

      {/* ===== SUCCESS HEADER ===== */}
      <div className="flex items-center justify-between rounded-lg mx-1 mt-4 px-4 py-4 shadow-sm border border-gray-200 mb-4">
        <div>
          <div className="flex items-center gap-3">
            <h2 className="text-base font-semibold text-gray-900">
              Order Confirmed
            </h2>
            <span className="text-green-600">
              ✔
            </span>
          </div>
          <p className="text-sm text-gray-600 mt-1">
            Payment received — RFQ converted to Order successfully.
          </p>
        </div>

        <div className="text-right">
          <div className="text-xs text-gray-500 mb-1">Order Number</div>
          <div className="px-3 py-1 border border-green-300 rounded-md bg-green-50">
            <span className="text-sm font-semibold text-green-700">
              {finalRfqData.order_number}
            </span>
          </div>
        </div>
      </div>

      {/* ===== ITEMS BY CATEGORY ===== */}
      {Object.entries(groupedItems).map(([category, items]) => (
        <div
          key={category}
          className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-4"
        >
          <h3 className="text-md font-semibold text-gray-800 mb-3">
            {category}
          </h3>

          <div className="space-y-3">
            {console.log("Rendering items for category:", category, items)} {/* Debug log */}
            {items.map((item) => (
            <div
  key={item._id}
  className={`flex items-start space-x-3 p-3 rounded-md border border-gray-200 
    ${item.not_available ? "bg-gray-100 opacity-60" : "bg-white"}`}
>
                {/* IMAGE */}
                <div className="w-14 h-14 bg-gray-50 rounded-md flex-shrink-0 flex items-center justify-center">
  {item?.item_image ? (
    <img
      src={imageurl + item.item_image}
      alt={item.item_name}
      className="w-full h-full object-contain rounded-md"
    />
  ) : (
    <div className="flex flex-col items-center justify-center text-xs text-gray-500 leading-tight">
      <span>No</span>
      <span>Image</span>
    </div>
  )}
</div>


                {/* DETAILS */}
                <div className="flex-1">
                  <h4 className="text-sm font-medium text-gray-900">
                    {item.item_name}
                  </h4>
                  <p className="text-xs text-gray-500">
                    ₹{item.selling_price} × {item.quantity} {item.UOM}
                  </p>
                </div>

                {/* PRICE */}
                <div className="text-right">
                  <div className="text-xs text-gray-400 line-through">
                    ₹{formatAmount(item.item_total_before_savings)}
                  </div>
               <div
                 className={`font-bold
                  ${item.not_available 
                   ? "text-red-500 text-sm" 
                   : "text-green-600 text-lg"}`}
                 >
               {item.not_available 
              ? "Not Available" 
              : `₹${formatAmount(item.item_total_after_savings)}`}
             </div>

                  {item.earned_build_coins > 0 && (
                    <span className="bg-blue-100 text-blue-800 px-2 py-0.5 rounded text-xs font-medium">
                      +{item.earned_build_coins} BuildCoins
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {/* ===== BILL SUMMARY ===== */}
      <div className="flex justify-end mt-6 ">
  <div className="w-[320px] border border-gray-200 rounded-lg bg-white p-4">
          <h3 className="text-md font-semibold text-gray-900 mb-4">
            Bill Summary
          </h3>

          <div className="space-y-3 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-500">Subtotal</span>
              <span className="font-medium">
                ₹{formatAmount(finalRfqData?.subtotal)}
              </span>
            </div>

            <div className="flex justify-between">
              <span className="text-gray-500">Tax</span>
              <span className="font-medium text-purple-600">
                +₹{formatAmount(finalRfqData?.tax_amount)}
              </span>
            </div>

            <div className="flex justify-between">
              <span className="text-gray-500">Discount</span>
              <span className="font-medium text-emerald-600">
                -₹{formatAmount(finalRfqData?.discount)}
              </span>
            </div>

           <div className="flex justify-between">
              <span className="text-gray-500">Delivery Charge</span>
              <span className="font-medium text-purple-600">
                ₹{formatAmount(finalRfqData?.delivery_charges || 0)}
              </span>
            </div>

            <div className="border-t pt-3 flex justify-between">
              <span className="font-semibold">Order Value</span>
              <span className="text-xl font-bold text-emerald-700">
                ₹{formatAmount(finalRfqData?.total)}
              </span>
            </div>

            <div className="flex justify-between text-xs text-gray-600">
              <span>BuildCoins Earned</span>
              <span>+{formatAmount(finalRfqData?.total_earned_build_coins)}</span>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}




  // DEFAULT (should not hit)
  return null;
};


export default RenderRFQStepContent